import VueI18n from 'vue-i18n'
import Vue from 'vue'
import dictionaryES from '../lang/dictionaryES'
import dictionaryEN from '../lang/dictionaryEN'

Vue.use(VueI18n)

const messages = {
  es: dictionaryES,
  en: dictionaryEN
}

const i18n = new VueI18n({
  locale: 'en',
  messages
})

export default i18n



// WEBPACK FOOTER //
// ./src/lib/i18n.js